import React, {useEffect, useState} from 'react';
import {Flex, Form, Input, message, Modal, Upload} from "antd";
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import classes from "../../Applications/application.module.css";
import FormItem from "antd/es/form/FormItem";
import {useTranslation} from "react-i18next";
import MicroQualificationService from "../../../../../services/MicroQualificationService";
import {useDispatch, useSelector} from "react-redux";
import MyText from "../../../../../components/UI/Text/MyText";
import MyTable from "../../../../../components/Table/MyTable";
import {changeCurrentPage} from "../../../../../store/slices/tableController/EducationFieldListTableController";
import {getAllEducationFields} from "../../../../../store/slices/EducationFieldsSlice";
import BlackerBlueButton from "../../../../../components/UI/Buttons/BlackerBlueButton";
import GreenButton from "../../../../../components/UI/Buttons/GreenButton";
import {UploadOutlined} from "@ant-design/icons";
import BhargaButton from "../../../../../components/UI/Buttons/BhargaButton";

const EducationFieldPage = () => {
    const [form] = Form.useForm();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {fields, isLoading, hasMore, error} = useSelector(state => state.educationFieldList)
    const {currentPage, pageSize} = useSelector(state => state.educationFieldListTableController);

    const nameRu = Form.useWatch('nameRu', form);
    const nameKz = Form.useWatch('nameKz', form);
    const nameEng = Form.useWatch('nameEng', form);
    const code = Form.useWatch('code', form);

    const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    const [openModal, setOpenModal] = useState(false)

    const [uploadedFile, setUploadedFile] = useState(null);

    const columns = [
        {
            title: <MyText center strong><IntlMessage id={"nameRu"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameRu}</MyText>
            ),
            width: '25%',
        },
        {
            title: <MyText center strong><IntlMessage id={"nameKz"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameKz}</MyText>
            ),
            width: '25%',
        },
        {
            title: <MyText center strong><IntlMessage id={"nameEng"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.nameEng}</MyText>
            ),
            width: '25%',
        },
        {
            title: <MyText center strong><IntlMessage id={"certificate.code"}/></MyText>,
            render: (_, record) => (
                <MyText center>{record.code}</MyText>
            ),
            width: '25%',
        },

    ];

    useEffect(() => {
        dispatch(getAllEducationFields({
            page: currentPage,
            limit: pageSize
        }));
    }, []);

    const saveCurrentPageSettings = (page, pageSize) => {
        dispatch(changeCurrentPage({page: page, pageSize: pageSize}));
    };

    const handleChangeExcel = (info) => {
        setUploadedFile(info.file);
    };

    const propsExcelFile = {
        beforeUpload: () => false,
        onChange: handleChangeExcel,
        multiple: false,
    };

    function handleCreate() {
        form.validateFields()
            .then(async (values) => {
                setIsLoadingCreate(true);
                setOpenModal(false)
                await MicroQualificationService.saveEducationField(nameRu, nameKz, nameEng, code)
                    .then(() => {
                        message.success(<IntlMessage id={'success'}/>)
                        form.resetFields();
                    })
                    .catch()
                    .finally()
            })
            .catch((error) => {
                console.log("Validation error!", error);
            })
            .finally(() => {
                dispatch(getAllEducationFields({
                    page: currentPage,
                    limit: pageSize
                }))
                setIsLoadingCreate(false);
                message.destroy();
            });
    }

    const fetchData = async (params) => {
        return dispatch(getAllEducationFields({
            ...params
        }));
    }

    const handleImportExcelFile = async () => {
        setIsLoadingCreate(true);
        await MicroQualificationService.importEducationFieldsByExcel(uploadedFile)
            .then(() => {
                message.success(<IntlMessage id={'success'}/>)
                setUploadedFile(null);
            })
            .catch()
            .finally(() => {
                dispatch(getAllEducationFields({
                    page: currentPage,
                    limit: pageSize
                }))
                setIsLoadingCreate(false);
                message.destroy();
            })
    }

    return (
        <Flex style={{width: "100%"}} gap={20} align={"flex-start"} justify={"flex-start"} vertical>
            <MyText uppercase strong size={"large"}><IntlMessage id={'educationField'}/></MyText>
            <Flex gap={"large"} justify={"center"} align={"center"}>
                <BlackerBlueButton onClick={() => {
                    setOpenModal(true)
                }}>
                    <IntlMessage id={'create'}/>
                </BlackerBlueButton>
                <Upload {...propsExcelFile} fileList={uploadedFile ? [uploadedFile] : []}>
                    <GreenButton>
                        <IntlMessage id={'certificate.excelFormat'}/>
                    </GreenButton>
                </Upload>
                {
                    uploadedFile &&
                    <BhargaButton icon={<UploadOutlined/>} onClick={handleImportExcelFile}><IntlMessage id={'upload'}/></BhargaButton>
                }
            </Flex>
            <MyTable
                isLoading={isLoading || isLoadingCreate}
                dataSource={fields}
                columns={columns}
                fetchData={fetchData}
                saveCurrentPage={saveCurrentPageSettings}
                initialPage={currentPage}
                initialPageSize={pageSize}
                hasMore={hasMore}
            />
            <Form form={form} className={classes.form} initialValues={{method: 'group'}}>
                <Modal
                    width={500}
                    maskClosable={true}
                    title={<IntlMessage id={'educationField'}/>}
                    open={openModal}
                    onOk={handleCreate}
                    onCancel={() => {
                        setOpenModal(false)
                    }}
                    okText={<IntlMessage id={'create'}/>}
                    cancelText={<IntlMessage id={'close'}/>}
                >
                    <Flex vertical style={{width: '100%'}} gap={4}>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameRu')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameRu">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameRu"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameKz')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameKz">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameKz"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  label={t('nameEng')}
                                  labelCol={{span: 24}}
                                  className={classes.formInput} style={{width: '100%', padding: 0}} name="nameEng">
                            <Input rootClassName={classes.formInput}
                                   placeholder={IntlMessageText.getText({id: "nameEng"})}/>
                        </FormItem>
                        <FormItem rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                                  name="code"
                                  label={<IntlMessage id="certificate.code"/>}
                                  labelCol={{span: 24}}
                                  className={classes.formInput}
                                  style={{width: '100%', padding: 0}}
                        >
                            <Input placeholder={t("certificate.code")}/>
                        </FormItem>
                    </Flex>
                </Modal>
            </Form>
        </Flex>
    );
};

export default EducationFieldPage;